import React from 'react';
import cx from 'classnames';

const TitleWrapper = ({ backgroundColor = '#ffffff', title, centerTitle, shouldUseSmallerTitleSize, breadcrumbs }) => {
  return (
    <div
      className={cx('BlocksOnlyTitleWrapper', {
        hasBreadcrumbs: breadcrumbs && breadcrumbs[0].includeBreadcrumbs,
      })}
      style={{ backgroundColor }}
    >
      <div className="BlocksOnlyInnerTitleWrapper">
        <h1
          className={cx('BlocksOnlyTitle', {
            isCenter: !!centerTitle,
            isSmaller: shouldUseSmallerTitleSize,
          })}
        >
          {title}
        </h1>
      </div>
    </div>
  );
};

export default TitleWrapper;
